import * as React from 'react';
import { Select, Label } from '../../../../modules/modules';

export interface IVariantSelectorOption {
  variant: GQL.IProductVariant;
  value: GQL.IAttributeValue;
}

interface IVariantSelectorProps {
  name: string;
  className?: string;
  value?: string;
  options: IVariantSelectorOption[];
  attribute: GQL.IAttribute;
  variant: GQL.IProductVariant;
  onChange: (variant: GQL.IProductVariant) => void;
}

class VariantSelector extends React.Component<IVariantSelectorProps> {

  constructor(props: IVariantSelectorProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { options } = this.props;

    if (options) {
      return (
        <div className={this.props.className || 'variantSelector'}>
          <Label text="Choose variant" />
          <Select
            name={this.props.name}
            value={this.props.value}
            clearFilterDisabled={true}
            options={options.map((option: IVariantSelectorOption) => {
              return { value: option.variant.id, label: option.value.title };
            })}
            onChange={this.onChange}
          />
        </div>
      );
    }

    return null;
  }

  private onChange(e: any) {
    if (this.props.onChange && this.props.options) {
      const variantId = e.target.value.value;
      const option = this.props.options.find((o: IVariantSelectorOption) => {
        return o.variant && o.variant.id === variantId;
      });
      if (option && option.variant) {
        this.props.onChange(option.variant as GQL.IProductVariant);
      }
    }
  }
}

export default VariantSelector;


// WEBPACK FOOTER //
// ./src/components/ProductDetail/components/VariantSelector/VariantSelector.tsx